import type { PlayNavigationId } from './playNavigationDestinations'

const paths: Record<PlayNavigationId, string> = {
  hub: 'M10 10h4v4h-4zM6 6l4 4M14 10l4-4M14 14l4 4M10 14l-4 4M2 2h4v4H2zM18 2h4v4h-4zM18 18h4v4h-4zM2 18h4v4H2z',
  strategy: 'M4 4h16v16H4zM4 12h16M12 4v16M8 8h.01M16 16h.01',
  puzzle:
    'M9 3H4v6h2a2 2 0 1 1 0 4H4v7h7v-2a2 2 0 1 1 4 0v2h5v-7h-2a2 2 0 1 1 0-4h2V3h-7v2a2 2 0 1 1-4 0z',
  online:
    'M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M2 20v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3M14 13h4a4 4 0 0 1 4 4v3',
  arcade:
    'M7 7h10a4 4 0 0 1 4 4l1 6a2 2 0 0 1-3 2l-3-3H8l-3 3a2 2 0 0 1-3-2l1-6a4 4 0 0 1 4-4M6 11v4M4 13h4M16 12h.01M19 14h.01',
  challenges: 'm13 2-9 12h7l-1 8 10-13h-7z',
  ranking:
    'M8 3h8v7a4 4 0 0 1-8 0zM8 5H4v3a4 4 0 0 0 4 4M16 5h4v3a4 4 0 0 1-4 4M12 14v5M8 21h8M9 19h6',
  tools: 'm14 6 4-4a6 6 0 0 0-8 7L3 16a3 3 0 0 0 4 4l7-7a6 6 0 0 0 8-7l-4 4z',
  home: 'm3 10 9-7 9 7M5 9v12h14V9M9 21v-8h6v8',
  rules: 'M4 4h6a3 3 0 0 1 3 3v14a3 3 0 0 0-3-3H4zM13 7a3 3 0 0 1 3-3h5v14h-5a3 3 0 0 0-3 3',
  education: 'm2 8 10-5 10 5-10 5zM6 10v6c4 3 8 3 12 0v-6M22 8v8',
  privacy: 'm12 2 8 4v6c0 5-8 10-8 10S4 17 4 12V6zM9 12l2 2 4-4',
  workshops: 'm4 20 4-1 12-12-3-3L5 16zM14 7l3 3M3 3h7M3 7h4',
  gateway: 'M10 4H4v16h6M14 8l4 4-4 4M8 12h12',
}

export default function PlayNavigationIcon({ id }: { id: PlayNavigationId }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[id]} />
    </svg>
  )
}
